import React from 'react';
import Popover from '../popover';


const PopoverInfo = ({ message, className, placement = 'right', width, ...props }) => {
    
    return (
        <Popover
            {...props}
            showOnHover={true}
            content={<div className={className || ''}>{message}</div>}
            theme='black'
            placement={placement}
            width={width}
            className={className}
        >
            <img src={'/images/icon/info-circle.svg'} alt='info' className='info-icon'/>
        </Popover>
    )
}

export default PopoverInfo
